"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Extension = void 0;
const json_crdt_patch_1 = require("../../json-crdt-patch");
class Extension {
    constructor(id, name, Node, Api, schema) {
        this.id = id;
        this.name = name;
        this.Node = Node;
        this.Api = Api;
        this.schema = schema;
    }
    new(...args) {
        return json_crdt_patch_1.s.ext(this.id, this.schema(...args));
    }
}
exports.Extension = Extension;
